import { withPrefix } from "gatsby";
// import PropTypes from "prop-types";
import React from "react";
import styled, { css } from "styled-components";

import {
  A,
  Link as SitesparkLink,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Html";
import {
  Facebook,
  Instagram,
  Linkedin,
  Twitter,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Social";
import {
  getFontFamily,
  getSize,
} from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

const StyledFooter = styled.footer`
  background-color: ${({
    theme: {
      colors: { white },
    },
  }) => white};
  color: ${({
    theme: {
      colors: { darkGrey },
    },
  }) => darkGrey};
  padding: 37px 40px 18px 40px;
  @media screen and (min-width: ${getSize("mobile480")}) {
    padding: 50px;
    padding-bottom: 30px;
  }
  @media screen and (min-width: ${getSize("tablet720")}) {
    padding-top: 42px;
  }
  @media screen and (min-width: ${getSize("tablet960")}) {
    padding: 38px 40px 40px 40px;
  }
  @media screen and (min-width: ${getSize("desktop1200")}) {
    padding: 50px;
  }
  @media screen and (min-width: ${getSize("desktop1920")}) {
    padding: 80px;
  }
`;

const FooterDiv = styled.div``;

const headerStyles = css`
  ${getFontFamily("regular")}
  color: ${p => p.theme.colors.blueGrey};
  font-size: 15px;
  -webkit-font-smoothing: antialiased;
  margin: 0;
  padding: 0;
  padding-bottom: 0.5em;
  text-transform: uppercase;
  :active, :focus, :hover {
    color: ${p => p.theme.colors.blueGrey};
  }
`;
const Header = styled.h2([""], headerStyles);

const FooterLinks = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const FooterLinkItem = styled.li`
  list-style: none;
  margin: 0;
  padding: 10px 0px;
`;

const aStyles = css`
  display: inline;
  width: auto;
  text-transform: uppercase;
  letter-spacing: normal;
  color: #b7b7b7;
  font-size: 15px;
  ${getFontFamily("regular")}
  &:hover,
  &:focus,
  &:active {
    color: ${p => p.theme.colors.grey};
  }
`;
const Link = styled(SitesparkLink)([""], aStyles);
const Anchor = styled(A)([""], aStyles);

const Address = styled.address`
  ${getFontFamily("regular")}
  color: #c1c1c1;
  font-size: 15px;
  font-style: normal;
  grid-area: contact;
  line-height: 20px;
  margin-top: 39px;
  text-transform: uppercase;
  @media screen and (min-width: ${getSize("tablet960")}) {
    bottom: 0;
    justify-self: end;
    position: absolute;
    text-align: right;
  }
  a {
    color: #c1c1c1;
    font-size: 15px;
    font-style: normal;
  }
`;

const Copyright = styled.p`
  ${getFontFamily("regular")}
  color: ${({
    theme: {
      colors: { lightGrey },
    },
  }) => lightGrey};
  font-size: 10px;
  grid-area: copyright;
  margin: 0;
  margin-top: 40px;
`;
const getApplicationsAnchorUri = ({ location: { pathname } }, elementId) => {
  const uri = withPrefix("/applications");
  return pathname.startsWith(uri) ? `#${elementId}` : `${uri}/#${elementId}`;
};

export function Footer(props) {
  return (
    <StyledFooter
      css={`
        @media screen and (min-width: ${getSize("tablet720")}) {
          align-items: start;
          display: grid;
          grid-column-gap: 52px;
          grid-template-areas:
            "overview partners support"
            "contact . social"
            "copyright copyright copyright";
          grid-template-columns: auto 1fr;
          grid-template-rows: auto auto auto;
        }
        @media screen and (min-width: ${getSize("tablet960")}) {
          grid-column-gap: 56px;
          grid-row-gap: 15px;
          grid-template-areas:
            "overview partners support social"
            "copyright noop . contact";
          grid-template-columns: auto auto 1fr;
          grid-template-rows: auto auto;
          position: relative;
        }
        @media screen and (min-width: ${getSize("desktop1200")}) {
          grid-column-gap: 90px;
        }
      `}
    >
      <FooterDiv css="grid-area: overview;">
        <Header>Overview</Header>
        <FooterLinks>
          <FooterLinkItem>
            <Link to="/">Savant Power</Link>
          </FooterLinkItem>
          <FooterLinkItem>
            <Link to="/how-it-works">How It Works</Link>
          </FooterLinkItem>
          <FooterLinkItem>
            <Link to="/applications">Applications</Link>
          </FooterLinkItem>
          <FooterLinkItem>
            <Link to="/utilities">Utilities</Link>
          </FooterLinkItem>
        </FooterLinks>
      </FooterDiv>
      <FooterDiv
        css={`
          grid-area: partners;
          margin-top: 12px;
          @media screen and (min-width: ${getSize("tablet720")}) {
            margin-top: unset;
          }
        `}
      >
        <Header>Partners</Header>
        <FooterLinks>
          <FooterLinkItem>
            <Link to="https://www.savant.com/">Savant</Link>
          </FooterLinkItem>
          <FooterLinkItem>
            <Link to="https://www.gelighting.com/">GE Lighting</Link>
          </FooterLinkItem>
        </FooterLinks>
      </FooterDiv>
      <FooterDiv
        css={`
          grid-area: support;
          margin-top: 12px;
          @media screen and (min-width: ${getSize("tablet720")}) {
            margin-top: unset;
          }
        `}
      >
        <Header>Support</Header>
        <FooterLinks>
          <FooterLinkItem>
            <Link to="/get-a-preliminary-proposal">
              Get a Preliminary Proposal
            </Link>
          </FooterLinkItem>
          <FooterLinkItem>
            <Link to="/become-a-savant-power-dealer">Become a Dealer</Link>
          </FooterLinkItem>
          <FooterLinkItem>
            <Link to="/resources">Resources</Link>
          </FooterLinkItem>
          <FooterLinkItem>
            <Link to="/careers">Careers</Link>
          </FooterLinkItem>
        </FooterLinks>
      </FooterDiv>
      <div
        css={`
          display: grid;
          gap: 34px;
          grid-template-columns: repeat(4, 34px);
          grid-area: social;
          margin-top: 66px;
          @media screen and (min-width: ${getSize("tablet720")}) {
            align-self: end;
            justify-self: end;
            margin-top: unset;
          }
          @media screen and (min-width: ${getSize("tablet960")}) {
            align-self: unset;
          }
        `}
      >
        <Facebook href={"https://www.facebook.com/PowerSavant"} />
        <Twitter href={"https://twitter.com/PowerSavant"} />
        <Instagram href={"https://www.instagram.com/savant_power/"} />
        <Linkedin href={"https://www.linkedin.com/company/74553249/"} />
      </div>
      <Address>
        <Header
          css={`
            padding-bottom: 1em;
            @media screen and (min-width: ${getSize("tablet720")}) {
              padding-bottom: 1.5em;
            }
          `}
        >
          Contact Us
        </Header>
        45 Perseverance Way
        <br />
        Hyannis, MA, 02601
        <br />
        United States
        <br />
        <br />
        <A href="tel:+15086832500">Phone 508.683.2500</A>
        <br />
        <br />
        <A href="mailto:sales@savantpower.com">sales@savantpower.com</A>
      </Address>
      <Copyright>©2021 Savant Systems, Inc</Copyright>
    </StyledFooter>
  );
}
